import React from 'react';
import { useNavigate } from 'react-router-dom';
import bwLogoRef from '../../../assets/images/techemlogo_final_sw.svg';
import { paths } from '../../../../frameworks_drivers/routes';

const FooterLogo = () => {
  const navigate = useNavigate();

  const onClick = (e: React.MouseEvent<HTMLImageElement>) => {
    navigate(paths.LandingPage);
    e.preventDefault();
  };

  return (
    <img
      alt="Techem Logo in Schwarzweiss"
      aria-label={'Startseite'}
      className="d-flex mx-0 my-auto clickable-image wp-100"
      src={bwLogoRef}
      onClick={onClick}
    />
  );
};
export { FooterLogo };
